
import { HubConnectionBuilder, LogLevel } from '@aspnet/signalr';

// See https://www.dotnetcurry.com/aspnet-core/1480/aspnet-core-vuejs-signalr-app

export default {
  install(Vue) {
    const connection = new HubConnectionBuilder()
      .withUrl('/vessel-activity-hub')
      .configureLogging(LogLevel.Information)
      .build();

    // use new Vue instance as an event bus
    const signalrEventBus = new Vue();

    // every component will use this.$signalrEventBus to access the event bus
    Vue.prototype.$signalrEventBus = signalrEventBus; // eslint-disable-line no-param-reassign

    // Forward server side SignalR events through $questionHub, where components will listen to them
    // connection.on('NewTankBunkerCreated', (siteId, bulkStoreId, bulkStoreName) => {
    //   signalrEventBus.$emit('bulk-store-created', { siteId, bulkStoreId, bulkStoreName })
    // })

    // connection.on('TankBunkerUpdated', (siteId, bulkStoreId, bulkStoreName) => {
    // signalrEventBus.$emit('bulk-store-updated', { siteId, bulkStoreId, bulkStoreName })
    // })

    let startedPromise = null;
    function start() {
      console.log('Starting vessel-activity-hub');
      startedPromise = connection.start()
        .then(() => {
          console.log('SignalR - Connection Established');
          Vue.prototype.$toast.success('Connected to Server');
          Vue.prototype.$signalrEventBus.$emit('connection-status', { connected: true });
        })
        .catch((err) => {
          console.error('Failed to connect with - Vessel-Activity-hub', err);
          return new Promise(
            // Try to reconnect every 15 seconds.
            (resolve, reject) => setTimeout(
              () => start().then(resolve).catch(reject), 15000,
            ),
          );
        });
      return startedPromise;
    }
    connection.onclose(() => {
      console.log('SignalR - Disconnected from server');
      Vue.prototype.$toast.warning('Server connection closed');
      Vue.prototype.$signalrEventBus.$emit('connection-status', { connected: false });
      start(); // Try to reconnect.
    });

    start(); // try to connect now.
  },
};


/*
From website above:
Note: if you are using 'dotnet watch run' to run the server application,
you will start experiencing the
 watch process crashing once you add the reconnect code.
This seems to happen because of the Hub connection keeping the port in
use so the restarted server process cannot start listening on the same port.

I haven’t found any solution other than restarting the watch process.
The alternative is to disable the reconnect code in development, but then you will
need to manually reconnect after server-side changes by reloading the page in the browser.
*/
